import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../components/Navbar/NavBar';
import heroImg from '../images/logo.png';

const Hero = () => {
    return (
        <>
            <div className="hero" id='hero'>
                <div>
                    <NavBar />
                </div>
                
                <div className="m-auto overflow-hidden mx-4 mt-8 lg:mt-4 p-2 md:p-12 h-5/6" data-aos="zoom-in">

                    <div id='hero' className="flex flex-col lg:flex-row py-8 justify-between text-center lg:text-left">
                        <div className="lg:w-1/2 flex flex-col justify-center" data-aos="zoom-in" data-aos-delay="200">
                            <h1 className="mb-5 md:text-5xl text-3xl font-bold text-orange-600">
                                Buy and Sell with people you trust
                            </h1>
                            <div className="text-xl font-semibold tracking-tight mb-5 text-gray-500">
                                Rally connects university students through a secure marketplace, making it easy to buy, sell, and trade within your campus community.
                            </div>
                            
                            {/* App Store Download Buttons */}
                            <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-4 mt-2 mb-8">
                                <a href="#" className="app-store-button bg-black text-white flex items-center justify-center px-4 py-2 rounded-xl shadow-lg hover:bg-gray-900 transition duration-300">
                                    <div className="mr-3">
                                        <svg viewBox="0 0 24 24" className="w-7 h-7 fill-current">
                                            <path d="M16.5 1H7.6c-.3 0-.6.1-.8.3-.2.2-.3.5-.3.8v19.7c0 .3.1.6.3.8.2.2.5.3.8.3h8.9c.3 0 .6-.1.8-.3.2-.2.3-.5.3-.8V2.1c0-.3-.1-.6-.3-.8-.2-.2-.5-.3-.8-.3z" fill="none" stroke="currentColor"></path>
                                            <circle cx="12" cy="20" r="1" fill="currentColor"></circle>
                                            <path d="M17.5 19.2v-16H6.5v16h11z" fill="currentColor"></path>
                                        </svg>
                                    </div>
                                    <div className="text-left">
                                        <div className="text-xs">Download on the</div>
                                        <div className="text-base font-semibold font-sans -mt-1">App Store</div>
                                    </div>
                                </a>
                                <a href="#" className="play-store-button bg-black text-white flex items-center justify-center px-4 py-2 rounded-xl shadow-lg hover:bg-gray-900 transition duration-300">
                                    <div className="mr-3">
                                        <svg viewBox="0 0 24 24" className="w-7 h-7 fill-current">
                                            <path d="M3.4 21L12 12.4 3.4 3.8c-.2.1-.3.4-.3.7v15.8c0 .3.1.6.3.7z" fill="currentColor"></path>
                                            <path d="M17.9 11.4L15.2 9.8 12.5 12.5l2.7 2.7 2.7-1.6c.8-.5.8-1.7 0-2.2z" fill="currentColor"></path>
                                            <path d="M5.9 2.2l8.8 8.2 2.7-1.6L5.9 2.2C5.4 1.8 4.7 1.8 4.2 2.2L5.9 3.8l7.5 5.8L5.9 2.2z" fill="currentColor"></path>
                                            <path d="M5.9 21.8L14.7 13.6l-2.7-1.6L5.9 21.8c-.5.3-1.2.3-1.8-.1l1.8-1.6 7.5-5.8L5.9 21.8z" fill="currentColor"></path>
                                        </svg>
                                    </div>
                                    <div className="text-left">
                                        <div className="text-xs">GET IT ON</div>
                                        <div className="text-base font-semibold font-sans -mt-1">Google Play</div>
                                    </div>
                                </a>
                            </div>
                            
                            <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-4">
                                <Link to="/contact" className="text-white bg-orange-500 hover:bg-orange-600 inline-flex items-center justify-center px-6 py-3 shadow-lg rounded-xl">
                                    Get Started
                                    <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                </Link>
                                <Link to="/get-demo" className="text-orange-500 bg-white border-2 border-orange-500 hover:bg-gray-50 inline-flex items-center justify-center px-6 py-3 shadow-lg rounded-xl">
                                    Learn More
                                </Link>
                            </div>
                        </div>
                        <div className="lg:w-1/2 flex flex-col justify-center items-center">
                            <img alt="App Screenshot" className="rounded-xl shadow-2xl" src={heroImg} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Hero;